import React from "react";

const HlpGoHome = () => {
  return (
    <>
      <h1>Home</h1>
      Go back to join or create a new effice.
    </>
  );
};

export default HlpGoHome;
